var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.isLoading
      ? _c(
          "div",
          [
            _c("div", { staticClass: "wrap-title-component" }, [
              _vm._v("\n      " + _vm._s(_vm.titleComponent) + "\n    ")
            ]),
            _vm._v(" "),
            _c("h5", { staticClass: "mb-4 text-capitalize" }, [
              _vm._v("\n      " + _vm._s(_vm.detailComponent.title) + "\n    ")
            ]),
            _vm._v(" "),
            _vm.hasSearchOptions
              ? _c(
                  "div",
                  { staticClass: "form-master mb-3" },
                  [
                    _c(
                      "b-row",
                      _vm._l(_vm.detailComponent.search_options_list, function(
                        field
                      ) {
                        return _c(
                          "b-col",
                          { key: field.field_data_key, attrs: { md: "6" } },
                          [
                            _c(
                              "b-form-group",
                              { staticStyle: { "margin-bottom": "10px" } },
                              [
                                _c(
                                  "label",
                                  { staticClass: "label-form-base" },
                                  [_vm._v(" " + _vm._s(field.name) + " ")]
                                ),
                                _vm._v(" "),
                                _c("field-preview", {
                                  attrs: {
                                    column: field,
                                    "use-drag-icon": false,
                                    "is-search": true
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      })
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex justify-content-between" }, [
              _c("div", { staticClass: "d-flex align-items-center" }, [
                _vm.hasSearchOptions
                  ? _c("button", { staticClass: "button-blue mr-2" }, [
                      _vm._v("\n          Search\n        ")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("button", { staticClass: "button-gray mr-2" }, [
                  _vm._v("Export Data")
                ]),
                _vm._v(" "),
                _vm.hasSearchOptions
                  ? _c("button", { staticClass: "button-clear" }, [
                      _vm._v("\n          Clear Filter\n        ")
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.useAdvanceReport
                ? _c("button", { staticClass: "button-activity" }, [
                    _c("img", {
                      staticClass: "mr-1",
                      attrs: {
                        src: require("@/assets/icon/activity.svg"),
                        width: "13",
                        height: "13"
                      }
                    }),
                    _vm._v("\n        See Activity\n      ")
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm.showTable
              ? _c("v-client-table", {
                  staticClass: "jTable",
                  attrs: {
                    data: [],
                    columns: _vm.columns,
                    options: _vm.tableOptions
                  }
                })
              : _vm._e()
          ],
          1
        )
      : _c("div", { staticClass: "skeleton-component" })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e37224c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e37224c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dummy/DummyExportView.vue
// module id = null
// module chunks = 